import { Icon } from '@iconify/react'
import { Button } from '@echodex/uikit'
import Link from 'next/link'

type Props = {
    totalAmount?: number
    description: string
    link: string
    nameButton: string
    icon?: string
}

const CardAirdrop = ({ totalAmount, description, link, nameButton, icon = 'fe:line-chart' }: Props) => {
    return (
        <div className="flex-1 overflow-hidden z-10 cursor-pointer border border-solid border-[#3b3a3a] p-[13px] flex flex-col relative rounded-xl [background:linear-gradient(179.44deg,_rgba(255,_253,_253,_0.19)_3.47%,_rgba(255,_255,_255,_0))] [backdrop-filter:blur(31px)] ">
            <div className="absolute h-[40px] z-[-1] top-[87.04%]  bottom-[0%] left-[calc(50%_-_83px)] rounded-xl bg-[rgb(128,130,135)] w-[165px] [filter:blur(22px)]" />
            <div className="flex justify-between mb-5">
                <div className="flex-1 flex flex-col gap-[8px]">
                    <div className=" leading-[21px] uppercase text-gray1 text-[13px]">you get</div>
                    <div className="  text-[24px] leading-[24px] uppercase font-semibold ">
                        {totalAmount ? totalAmount.toFixed(2) : 0}
                    </div>
                    <div className=" text-gray1 text-xs leading-[18px] font-medium">{description}</div>
                </div>
                <div className=" bg-[#51535a] rounded-full w-8 h-8 flex-center">
                    <Icon icon={icon} className=" w-[21px] h-[21px] overflow-hidden shrink-0 " />
                </div>
            </div>
            <Link href={link} className="block w-full">
                <Button scale="md" style={{ fontSize: '15px' }} className="relative leading-[21px] font-medium w-full">
                    {nameButton}
                </Button>
            </Link>
        </div>
    )
}

export default CardAirdrop
